const mutations = {
    set(state, _object) {
        state.item = {
            default: {
                comission: '',
                deployment_commision: '',
                comission_contemplation: '',
                billing_commission: '',
                billing_commission_type: 'F',
                min_quotes: '',
                max_quotes: '',
                commissioned_vehicles: [],
                inadvertencies: [],
                groups: []
            },
            bonus: {
                initial_date: '',
                final_date: '',
                qtd_quotas: '',
                bonus_1: '',
                cut_value: '',
                bonus_2: '',
                by_quotas: []
            },
            billing: {
                ranges: []
            },
            campaign: {
                initial_date: '',
                final_date: '',
                min_quantity: 0,
                Commission: 0,
                quotas: [],
                amounts: [],
                closing_months: []
            },
            installments: [],
            inadvertencies: [],
            surplus: {
                min_value: 0,
                commision_on_first_installment: 0,
                commision_on_second_installment: 0
            },
            type_sales: []
        };

        setTimeout(function() {
            if (_object !== null) {
                // Define Default Commission
                if (_object.default !== undefined && _object.default !== null) {
                    state.item.default.comission = _object.default.comission;
                    state.item.default.min_quotes = _object.default.min_quotes;
                    state.item.default.max_quotes = _object.default.max_quotes;
                    state.item.default.deployment_commision = _object.default.deployment_commision;
                    state.item.default.commissioned_vehicles = _object.default.commissioned_vehicles;
                    state.item.default.inadvertencies = _object.default.inadvertencies;
                    state.item.default.comission_contemplation = _object.default.comission_contemplation;
                    state.item.default.billing_commission_type = _object.default.billing_commission_type;
                    state.item.default.billing_commission = _object.default.billing_commission;
                    state.item.default.groups = _object.default.groups;
                }

                // Define Bonus Commission
                if (_object.bonus !== undefined && _object.bonus !== null) {
                    state.item.bonus.initial_date = _object.bonus.initial_date;
                    state.item.bonus.final_date = _object.bonus.final_date;
                    state.item.bonus.qtd_quotas = _object.bonus.qtd_quotas;
                    state.item.bonus.bonus_1 = _object.bonus.bonus_1;
                    state.item.bonus.cut_value = _object.bonus.cut_value;
                    state.item.bonus.bonus_2 = _object.bonus.bonus_2;
                    state.item.bonus.by_quotas = _object.bonus.by_quotas;
                }

                // Define Billing Ranges Commission
                if (_object.billing_ranges !== undefined && _object.billing_ranges !== null) {
                    state.item.billing.ranges = _object.billing_ranges;
                }

                // Define Campaign Commission
                if (_object.campaign !== undefined && _object.campaign !== null) {
                    const campaign = _object.campaign;
                    state.item.campaign.initial_date = campaign.initial_date;
                    state.item.campaign.final_date = campaign.final_date;
                    state.item.campaign.min_quantity = campaign.min_quantity > 0 ? campaign.min_quantity : 0;
                    state.item.campaign.commission = campaign.commission > 0 ? campaign.commission : 0;
                    state.item.campaign.quotas = campaign.quotas;
                    state.item.campaign.amounts = campaign.amounts;
                    state.item.campaign.closing_months = campaign.closing_months;
                }

                // Define Installments Commission
                if (_object.installments !== undefined && _object.installments !== null) {
                    state.item.installments = _object.installments;
                }

                // Define Inadvertencies
                if (_object.inadvertencies !== undefined && _object.inadvertencies !== null) {
                    state.item.inadvertencies = _object.inadvertencies;
                }

                if (_object.surplus !== undefined && _object.surplus !== null) {
                    state.item.surplus.min_value = _object.surplus.min_value;
                    state.item.surplus.commision_on_first_installment = _object.surplus.commision_on_first_installment;
                    state.item.surplus.commision_on_second_installment = _object.surplus.commision_on_second_installment;
                } else {
                    state.item.surplus.min_value = 0;
                    state.item.surplus.commision_on_first_installment = 0;
                    state.item.surplus.commision_on_second_installment = 0;
                }

                if (_object.type_sales !== undefined && _object.type_sales !== null) {
                    state.item.type_sales = _object.type_sales;
                }
            }
        }, 200)
    }
};

export default mutations;